export default __webpack_public_path__ + "images/fundal_blue.d0f66d578e539b0224a1c5b4669da09a.png";